import Facebook from 'src/assets/Icons/facebook_13_11zon.avif'
import Instagram from 'src/assets/Icons/instagram_14_11zon.avif'
import TikTok from 'src/assets/Icons/tiktok_17_11zon.avif'
import LinkedIn from 'src/assets/Icons/linkedin_15_11zon.avif'
import Spotify from 'src/assets/Icons/spotify_16_11zon.avif'
import { SocialLabels, FooterLabels } from 'src/types'
import { useTranslations } from 'src/provider/LocaleProvider'

export const FooterSocial: SocialLabels[] = [
    {
        id: 1,
        icon: Instagram,
        name: 'Instagram',
        link: 'https://instagram.com/blureffectdev_?igshid=YmMyMTA2M2Y=',
        linkEs: 'https://instagram.com/blureffect_dev?igshid=YmMyMTA2M2Y=',
    },
    // {
    //     id: 2,
    //     icon: WhatApp,
    //     name: 'WhatApp',
    //     link: 'https://wa.me/message/GEFEQ2AE5UMBK1',
    //     linkEs: 'https://wa.me/message/GEFEQ2AE5UMBK1',
    // },
    {
        id: 3,
        icon: LinkedIn,
        name: 'LinkedIn',
        link: 'https://www.linkedin.com/company/blur-effect/',
        linkEs: 'https://www.linkedin.com/company/blur-effect/',
    },
    {
        id: 4,
        icon: TikTok,
        name: 'TikTok',
        link: 'https://www.tiktok.com/@blureffectdev?_t=8VXkqQBrlAM&_r=1',
        linkEs: 'https://www.tiktok.com/@blureffectdev?_t=8VXkqQBrlAM&_r=1',
    },
    {
        id: 5,
        icon: Spotify,
        name: 'Spotify',
        link: 'https://open.spotify.com/show/5DHIrbP878LS3fjaSryHxe',
        linkEs: 'https://open.spotify.com/show/5DHIrbP878LS3fjaSryHxe',
    },
    {
        id: 6,
        icon: Facebook,
        name: 'Facebook',
        link: 'https://www.facebook.com/profile.php?id=100085850049689',
        linkEs: 'https://www.facebook.com/profile.php?id=100085850049689',
    },
]

export function FooterLabels() {
    const t = useTranslations()
    const FooterInformation: FooterLabels[] = [
        {
            id: 1,
            title: `${t('footer.aboutUs')}`,
            component: [
                {
                    id: 1,
                    link: '',
                    content: `${t('footer.ourStory')}`,
                },
                {
                    id: 2,
                    link: 'team',
                    content: `${t('footer.ourTeam')}`,
                },
                {
                    id: 3,
                    link: 'buildToProject',
                    content: `${t('footer.careers')}`,
                },
            ],
        },
        {
            id: 2,
            title: 'Company',
            component: [
                {
                    id: 1,
                    link: 'services',
                    content: `${t('services.ourServices')}`,
                },
                {
                    id: 2,
                    link: 'successStories',
                    content: `${t('footer.clients')}`,
                },
                {
                    id: 3,
                    link: 'bookACall',
                    content: `${t('footer.contact')}`,
                },
            ],
        },
        {
            id: 3,
            title: 'Resources',
            component: [
                {
                    id: 1,
                    link: 'blog',
                    content: `${t('cta.blog')}`,
                },
                {
                    id: 2,
                    ruta: 'https://blur-effect.s3.amazonaws.com/public/Legal+Advice+Web.docx.pdf',
                    linkDirection: true,
                    content: `${t('footer.legalNotice')}`,
                },
                {
                    id: 3,
                    ruta: 'https://blur-effect.s3.amazonaws.com/public/Poli%CC%81tica+de+Privacidad+Web.pdf',
                    linkDirection: true,
                    content: `${t('footer.privacyPolicy')}`,
                },
                {
                    id: 4,
                    ruta: 'https://blur-effect.s3.amazonaws.com/public/Poli%CC%81tica+de+cookies+Web.pdf',
                    linkDirection: true,
                    content: `${t('footer.cookiePolicy')}`,
                },
            ],
        },
        {
            id: 4,
            title: `${t('footer.contactUs')}`,
            component: [
                {
                    id: 1,
                    content: '(323) 414-2211',
                    ruta: 'https://api.whatsapp.com/send?phone=573234142211',
                    linkDirection: true,
                },
                {
                    id: 2,
                    content: 'accounting@blureffect.co',
                    ruta: 'mailto:accounting@blureffect.co',
                    linkDirection: true,
                },
                {
                    id: 3,
                    content: 'Cra 9B #10-112',
                    ruta: 'https://www.google.com/maps/place/Blur+Effect/@10.9892053,-74.9558456,16.63z/data=!4m6!3m5!1s0x8ef5d2b5811d260f:0xf06305b7cd21cc56!8m2!3d10.989492!4d-74.9540578!16s%2Fg%2F11sqd3xw61?entry=ttu',
                    linkDirection: true,
                },
            ],
        },
    ]
    return { FooterInformation }
}
